import React from 'react';
import moment from 'moment';

import { dateFormatter, priceFormatter } from '../../utils/Formatters';
import { getPayments } from '../../queries/Queries';
import QueryDataTable from '../../components/QueryDataTable/QueryDataTable';

const PaymentsView = ({ data, match }) => {
  const columns = [
    {
      dataField: 'accountNumber',
      text: 'Account Number',
      sort: true,
    },
    {
      dataField: 'paymentDate',
      text: 'Date',
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: 'amount',
      text: 'Amount',
      formatter: priceFormatter,
      sort: true,
    },
  ];

  // Determine customer ID from data prop for single customer role or URL params for multiple
  const customerId = data ? data.Customer.content[0].id : match.params.param;

  const buildWhereClause = (filters) => {
    let whereClause = `account.customer.id == ${customerId}`;

    if (filters.accountNumber) {
      whereClause += ` and account.number==*${filters.accountNumber}*`;
    }

    if (filters.startDate && filters.endDate) {
      whereClause += ` and paymentDate >= ${filters.startDate.toISOString()} and paymentDate <= ${filters.endDate.toISOString()}`;
    }

    return whereClause;
  };

  const transformData = (content) => {
    return content.map((payment) => ({
      id: payment.id,
      paymentDate: payment.paymentDate,
      accountNumber: payment.account.number,
      amount: payment.amount,
    }));
  };

  return (
    <QueryDataTable
      title='Payments'
      query={getPayments}
      columns={columns}
      defaultSort={{ field: 'paymentDate', order: 'desc' }}
      pageSizes={[5, 10, 20]}
      filters={[
        {
          type: 'text',
          name: 'accountNumber',
          placeholder: 'Search by Account Number',
          colSize: 8,
          defaultValues: '',
          useDebounce: true,
        },
        {
          type: 'dateRange',
          name: 'dateRange',
          startDateField: 'startDate',
          endDateField: 'endDate',
          colSize: 4,
          defaultValues: {
            startDate: moment().subtract(1, 'year').startOf('day'),
            endDate: moment().startOf('day'),
          },
        },
      ]}
      buildWhereClause={buildWhereClause}
      transformData={transformData}
      queryName='Payment'
    />
  );
};

export default PaymentsView;
